export const MAX_FILE_SIZE_MB = 20;
